import $ from 'jquery'
import './flash.js'

// setup modal faq booking info tab
$(document).on('click', '#add-faq-btn', function() {
  let id = Math.random() * Math.pow(10, 17);
  let currentIndex = parseInt($('#faq-list').data('index'));
  let newTemplate = $(this).data('template').replace(/value_to_replace_with_js/g, currentIndex);

  let form = $(`<div class="tab-pane" data-id="${id}">`).html(newTemplate)
      .appendTo('#faq-list');

  $('#faq-list').data('index', currentIndex + 1);

  let link = $(`<a class="dropdown-item" data-id="${id}" href="#">Edit</a>`)
      .prependTo('#faq-dropdown .dropdown-menu')
      .trigger('click')

  $('#faq-dropdown').show()
  form.find('.modal').modal({ backdrop: 'static', show: true })
  $(".faq-display-selected").selectize({
    delimiter: ',',
    onDropdownOpen: function() {
      $('.selectize-dropdown-content').on('mousedown', 'div[data-selectable]', function() {
        let value = $(this).closest('.faq-display-selected').closest(".display-faq-options").find(".faq-display-gpt").val();
        value = value ? value + ',' + $(this).attr('data-value') : $(this).attr('data-value');
        $(this).closest('.faq-display-selected').closest(".display-faq-options").find(".faq-display-values").val(value);
      });
    }
  });
  return false
})
